import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Slide,
} from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import CloseIcon from "@mui/icons-material/Close";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import toast from "react-hot-toast";
import useMediaQuery from "@mui/material/useMediaQuery";

import CompanyInfoComp from "./CompanyInfo"
import LeftSideComp from "./LeftSideComp";
import { signUpSchema } from "../../schema/signUpSchema";
import { createTenant } from "../../services/createTenant.js";
import { clickEvent } from "../../utils/helpers/createEvent.js";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function SignUpComp({ open, handleClose, thankYouOpen }) {
  const isTablet = useMediaQuery("(max-width: 767px)");
  const [submitLoading, setSubmitLoading] = React.useState(false);

  const [activeStep, setActiveStep] = React.useState(0);
  const methods = useForm({
    resolver: yupResolver(signUpSchema),
    defaultValues: {},
    mode: "onBlur",
  });

  const handleSubmit = async (formData) => {
    setSubmitLoading(true);
    const data = { ...formData };

    const localPhone = (data.phone_number || "").replace(/\D/g, "");
    const phoneWithCode =
      localPhone && data?.phone_country_code
        ? `+${data.phone_country_code}${localPhone}`
        : data.phone_number;

    delete data.phone_country_code;

    createTenant({ ...data, phone_number: phoneWithCode, plan_id: "Free" })
      .then((res) => {
        const eventData = {
          category: "Signup Form",
          action: `Signup Form Submitted Successfully.`,
          debug_mode: true,
        }

        clickEvent(eventData);
        thankYouOpen(res.data);
        handleClose();
        setSubmitLoading(false);
      })
      .catch((err) => {
        console.log("error == ", err);
        toast.error(err.response.data.message);
        setSubmitLoading(false);
      });
  };

  return (
    <>
      <Dialog
        fullScreen={isTablet}
        fullWidth={isTablet}
        maxWidth={isTablet ? undefined : "md"}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        className="signup-popup"
        TransitionComponent={Transition}
      >
        <DialogContent sx={{ p: 0 }}>
          <Grid2 container spacing={0}>
            <LeftSideComp />
            <Grid2 size={{ md: 7, sm: 7, xs: 12 }} p={0}>
              <DialogTitle className="close-popup" sx={{ padding: "6px" }}>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={handleClose}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>

              <div className="steps-column">
                <FormProvider {...methods}>
                  <form onSubmit={methods.handleSubmit(handleSubmit)}>
                    <div>
                      <div className="form-content">
                        <CompanyInfoComp
                          activeStep={activeStep}
                          handleBack={handleClose}
                          setActiveStep={setActiveStep}
                          isLoading={submitLoading} />
                      </div>
                    </div>
                  </form>
                </FormProvider>
              </div>
            </Grid2>
          </Grid2>
        </DialogContent>
      </Dialog>
    </>
  );
}
